module.exports = __webpack_public_path__ + "img/team-okr.45c734a1.svg";